export default "__VITE_ASSET__GAZR4LE4__"